module.exports = __webpack_public_path__ + "static/media/iflip.d9b4c713.png";